<template>
    <section class="online-business">
        <h4>
            <div>Comece a monetizar</div>
            <div> em <span>apenas 3 passos</span></div>
        </h4>
        <div class="online-business-steps">
            <div v-for="( step, index ) in steps" :key="index"
            class="online-business-step">
                <q-img :src="step.image" loading="lazy" class="image" />
                <p v-html="step.title" class="title"></p>
                <span v-text="step.subtitle" class="subtitle" />
            </div>
        </div>
    </section>
</template>
<script setup>
const steps = [
    { 
        number: 1, 
        title: `1. Cadastre-se`,
        subtitle: 'Preencha suas informações',
        image: 'https://flip.net.br/wp-content/uploads/2025/02/cadastro-3.png'
    },
    { 
        number: 2, 
        title: `2. Compartilhe`,
        subtitle: 'Recomende produtos ou cupons de desconto',
        image: 'https://flip.net.br/wp-content/uploads/2025/02/alto-falante-1.png'
    },
    { 
        number: 3, 
        title: `3. Ganhe Dinheiro`,
        subtitle: 'Receba pagamentos pelas vendas que você gerar',
        image: 'https://flip.net.br/wp-content/uploads/2025/02/bolsa-de-dinheiro-1.png'
    }
]
</script>
<style scoped>
.online-business {
    margin: 90px 0px 70px 0px;
}

.online-business h4 {
    margin: 0 auto;
    text-align: center;
    font-size: max(25px, min(5vw, 32px));
    font-weight: bold;
    color: #5E5E5E;
}

.online-business div:first-child {
    font-weight: 600;
}

.online-business div:last-child {
    font-weight: 700;
}


.online-business h4 > div > span {
    text-align: center;
    position: relative;
}


.online-business h4 > div > span::before {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 3px;
    background-color: var(--flip-color-primary);
    transform-origin: 140px 0px;
    transform: rotate(-1.8deg);
  }

.online-business-steps {
    display: grid;
    gap: 2rem;
    margin-top: 2.5rem;
    justify-content: center;
}

.online-business-step {
    text-align: center;
}

.online-business-step-number {
    background-color: var(--flip-color-primary);
    border-radius: 50%;
    width: 62px;
    height: 62px;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    display: flex;
    color: #fff;
    font-weight: 900;
    font-size: max(32px, min(5vw, 40px));
}

.image {
    width: 58px;
    border-radius: 50%;
}

.title {
    text-align: center;
    margin: 12px auto 0 auto;
    font-size: max(15px, min(3vw, 17px));
    font-weight: 500;
    color: #5E5E5E;
}

.subtitle {
    color: #667082;
    font-weight: 400;
    font-size: max(12.5px, min(3vw, 13px));
}

@media (min-width: 599.99px) {
    .online-business {
        margin: 90px 0px;
    }

    .title {
        max-width: 52%;
        text-align: center;
        margin: 12px auto 0 auto;
        height: 30px;
    }

    .online-business-steps {
        display: flex;
        gap: 1rem
    }
}

@media (min-width: 1180px) {
    .online-business h4 {
        text-align: left;
        margin: 0px;
        margin-right: 40px !important;
        white-space: nowrap;
    }

    .title {
        width: 250px;
        margin: 12px auto 0 auto;
        max-width: 67%;
    }

    .online-business {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>